import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/**
 * The single MSAL instance for the app.
 *
 * This lives outside main.jsx deliberately. The API layer (utils/ApiCall.js,
 * utils/ApiCallPostOnly.js) needs the instance, and importing it from the entry
 * point meant that importing any state hook executed the whole application
 * bootstrap, including ReactDOM.createRoot.
 *
 * Bootstrap sequencing (initialize, active account, event callbacks) stays in
 * main.jsx; this module only owns construction.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
